import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { Discipline } from '@centers/interfaces/discipline';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import BpcDisciplineOnlineBookingConfigForm from '@centers/components/forms/discipline-online-booking-config-form.vue';
import { DisciplineOnlineBookingConfig } from '@centers/interfaces/online-booking-config';
import Section from '@shared/components/forms/inputs/section/section.vue';

library.add(faSync);

@Component({
  name: 'bpc-discipline-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    BpcDisciplineOnlineBookingConfigForm,
    'bc-section': Section,
  },
})
export default class DisciplineTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    onlineBookingConfigForm: InstanceType<typeof BpcDisciplineOnlineBookingConfigForm> & {
      manageSaveErrors(errors: any): void;
    };
  };
  public entity: Discipline = null;
  public formModel: Discipline = null;
  public entityName = 'discipline';
  public pluralEntityName = 'disciplines';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {};
  public customRowActions = {
    details: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'details',
    },
  };

  public showOnlineBookingConfigForm: boolean = false;
  public disciplineOnlineBookingConfig: DisciplineOnlineBookingConfig = null;
  public disciplineLevels: string[] = [];

  constructor() {
    super();
  }

  get showDisciplineLevels(): boolean {
    return (
      this.formModel.enable_online_booking &&
      this.formModel.enable_matchmaking &&
      this.formModel.enable_multiplayer_booking
    );
  }

  addDisciplineLevel() {
    this.disciplineLevels.push('');
  }

  removeDisciplineLevel(index: number) {
    this.disciplineLevels.splice(index, 1);
  }

  customOnRowAction($event: { event: string; item: any }) {
    const actionName = $event.event === 'public-details' ? 'publicDetails' : $event.event;
    if ($event.item.item.actions[actionName].activated) {
      switch ($event.event) {
        case 'details':
          this.$router.push({
            name: 'public-discipline-details',
            params: { alias: $event.item.item.alias },
          });
          break;
      }
    }
  }

  mounted() {
    this.showOnlineBookingConfigForm = false;
  }

  actionBeforeSaveForm(formModel) {
    delete formModel.optionGroup;
    formModel.onlineBookingConfig = this.disciplineOnlineBookingConfig;

    const disciplineLevelsToStore = this.disciplineLevels
      .filter(value => value)
      .map((value, index) => ({
        name: value,
        order: index,
      }))
      .sort((a, b) => a.order - b.order);

    formModel.discipline_levels = disciplineLevelsToStore;

    return formModel;
  }

  onModelLoaded(formModel: Discipline) {
    const defaultModel = this.getDefaultDisciplineOnlineBookingConfig();
    const valueModel = formModel?.optionGroup?.options?.booking;
    this.disciplineOnlineBookingConfig = valueModel
      ? {
          ...defaultModel,
          ...valueModel,
        }
      : defaultModel;
    this.disciplineLevels =
      formModel.discipline_levels?.map(level => level.name).sort((a, b) => a - b) ?? [];

    this.showOnlineBookingConfigForm = true;
  }

  onValidationErrorsChanged(errorsObject) {
    console.log('onValidationErrorsChanged', errorsObject);

    const onlineBookingConfigErrors = Object.keys(errorsObject).reduce((output, key) => {
      if (key.startsWith('onlineBookingConfig.')) {
        const newKey = key.replace('onlineBookingConfig.', '');
        output[newKey] = errorsObject[key];
      }
      return output;
    }, {} as { [key: string]: any });

    this.$refs.onlineBookingConfigForm.manageSaveErrors(onlineBookingConfigErrors);
  }

  getDefaultDisciplineOnlineBookingConfig(): DisciplineOnlineBookingConfig {
    return {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      max_number_of_ongoing_upcoming_bookings_when_online_payment: '999',
      max_number_of_ongoing_upcoming_bookings_when_subscription_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_online_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_subscription_payment: '999',
      min_time_between_two_bookings: '12',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      min_time_before_player_slot_cancellation: '48',
      reminder_hours_before_cancellation_deadline: '48',
      membership_required: false,
      memberships_allow_booking: [],
      automatic_resource_selection: false,
      start_time: '08:00',
      step_duration: 60,
      only_with_subscriptions: 'subscription_only',
    };
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
